import React from 'react';
import { Container } from 'react-bootstrap';
import BlogLayout from './BlogLayout';
import { getPostBySlug } from '../blog/posts';
import { useDocumentMeta } from './BlogPage';

function formatDate(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

// Renders a single blog post resolved from its URL slug. Unknown slugs show a
// friendly not-found state with a link back to the blog index.
function BlogPostPage({ slug }) {
  const post = getPostBySlug(slug);

  useDocumentMeta(
    post ? `${post.title} | Plum` : 'Post not found | Plum',
    post ? post.description : 'This article could not be found.'
  );

  if (!post) {
    return (
      <BlogLayout>
        <Container style={{ maxWidth: '800px' }} className="py-4">
          <h1>Post not found</h1>
          <p>The article you are looking for doesn't exist or may have moved.</p>
          <p>
            <a href="/blog">← Back to the blog</a>
          </p>
        </Container>
      </BlogLayout>
    );
  }

  const Body = post.body;

  return (
    <BlogLayout>
      <Container style={{ maxWidth: '800px' }} className="py-4">
        <p className="mb-3">
          <a href="/blog" className="text-decoration-none">
            <i className="bi bi-arrow-left me-2"></i>Back to the blog
          </a>
        </p>

        <article>
          <h1>{post.title}</h1>
          <p className="text-muted">
            {formatDate(post.date)} · {post.readMinutes} min read · {post.author}
          </p>
          <div className="blog-post-body mt-4">
            <Body />
          </div>
        </article>
      </Container>
    </BlogLayout>
  );
}

export default BlogPostPage;
